import { AccessTypes, AssetsInterface } from "@/types";
import { usersModule } from "@/store";
import { checkAccess } from "@/permission";

export function hasAccessToAsset(asset: AssetsInterface | undefined): boolean {
  if (!asset) {
    return false;
  }

  if (!usersModule.IsAuthenticated) {
    return checkAccess(
      AccessTypes.Guest,
      asset?.accessType ?? AccessTypes.Guest
    );
  }

  return checkAccess(
    usersModule.userData.access as number,
    asset?.accessType ?? AccessTypes.Guest
  );
}

export function hasAccessToPinnedAssets(): boolean {
  return checkAccess(
    usersModule.userData.access as number,
    AccessTypes.Registered
  );
}
